export const InitativePeople = () => {
  return (
    <div className="container">
      <div className="initative-container section">
        <div className="initative-text-container">
          <div className="out-fit-title-text-mini">Initative People</div>
          <div className="set-desktop out-fit-detail-text mt-20">
            The idea of the project was initiated by these people.<br></br>{" "}
            However, it is YOU the Homies who would be founding
          </div>
          <div className="set-mobile out-fit-detail-text mt-20">
            The idea of the project was initiated by these people.However, it is
            YOU the Homies who would be founding
          </div>
        </div>
        <div className="initative-image-display">
          <div className="initative-image-container"></div>
          <div className="initative-image-container"></div>
          <div className="initative-image-container"></div>
          <div className="initative-image-container"></div>
        </div>
      </div>
    </div>
  );
};
